import SvgCloseMEP from '@img/icons/close-mep.svg';
import SvgClose from '@img/icons/close.svg';
import { basket } from '@redux/slices/basket';
import { useAppDispatch, useAppSelector } from '@redux/store';
import CartProductCard from '@stories/Components/Cards/CartProductCard/CartProductCard';
import { Device, until } from '@helpers/media';
import Button from '@stories/Components/Global/Buttons/Button/Button';
import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { ToastContainer } from 'react-toastify';
import useMedia from 'react-use/esm/useMedia';
import Background from './Background/Background';
import S from './CartOverlay.styles';
import Upsell from './Upsell/Upsell';
const CartOverlay = (props) => {
    const dispatch = useAppDispatch();
    const basketState = useAppSelector((state) => state.basket);
    const isMobile = useMedia(until(Device.DesktopSmall), false);
    /**
     * Memoise shown items so that deleted items can be retained.
     * Use an iterable version (clear whenever the over closes) to
     * trigger new items to be added to the list if added via an upsell card
     */
    const newItems = React.useMemo(() => {
        if (basketState.drawer === 'open-new') {
            return basketState.items?.filter((item) => item.newlyAdded) ?? [];
        }
        else {
            return basketState.items ?? [];
        }
    }, [basketState.drawer]);
    const [newlyAdded, setNewlyAdded] = React.useState([]);
    /** Combine items added while drawer is open to the newlyAdded state items */
    React.useEffect(() => {
        if (basketState.drawer === 'open-new') {
            const newest = basketState.items?.filter((item) => item.newlyAdded) ?? [];
            setNewlyAdded([...newlyAdded, ...newest]);
        }
    }, [basketState.version]);
    /** Reset newlyAdded when drawer closes */
    React.useEffect(() => {
        if (basketState.drawer === 'closed') {
            setNewlyAdded([]);
        }
    }, [basketState.drawer]);
    const basketItems = basketState.drawer === 'open-new'
        ? [...newItems, ...newlyAdded]
        : basketState.drawer === 'open'
            ? [...newItems]
            : [];
    const upsell = basketState.upsell;
    const paymentSummary = basketState.paymentSummary;
    const currentProductPageId = basketState.drawer === 'open-new' ? basketItems[0]?.kenticoSkuId : undefined;
    return (React.createElement(S.Container, { "data-open": basketState.drawer !== 'closed' || false, "data-site": props.site },
        React.createElement(Background, null),
        React.createElement(S.Drawer, { "data-has-upsell": !!upsell && upsell.items.length > 0 },
            !isMobile && upsell && upsell.items.length > 0 && (React.createElement(Upsell, { ...upsell, buttonLabel: props.upsellButtonLabel ?? 'Add to Cart', showPrice: props.site === 'ess' || paymentSummary?.accountType === 'credit', site: props.site, currentProductPageId: currentProductPageId })),
            React.createElement(S.DrawerMain, null,
                React.createElement(S.TitleWrapper, null,
                    React.createElement(S.Title, null,
                        "Your ",
                        props.name),
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.CloseButton, { "aria-label": `Close ${props.name} overlay`, onClick: closeCartOverlay }, props.site === 'mep' ? React.createElement(SvgCloseMEP, null) : React.createElement(SvgClose, null)))),
                React.createElement(S.InnerWrapper, null,
                    (basketItems === null || basketItems?.length === 0) && (React.createElement(React.Fragment, null, "No products were added to your cart")),
                    React.createElement(S.CardWrapper, null, basketItems?.map((bi) => (React.createElement(CartProductCard, { key: `${bi.id}-cart-overview-card`, ...bi, excludedDates: props.excludedDates, site: props.site, location: props.location, variant: "overlay", showPrice: props.site === 'ess' || paymentSummary?.accountType === 'credit', currentProductPageId: currentProductPageId })))),
                    isMobile && upsell && upsell.items.length > 0 && (React.createElement(Upsell, { ...upsell, buttonLabel: props.upsellButtonLabel ?? 'Add to Cart', showPrice: props.site === 'ess' || paymentSummary?.accountType === 'credit', site: props.site, currentProductPageId: currentProductPageId }))),
                React.createElement(S.ButtonWrapper, null,
                    React.createElement(Button, { buttonType: "outline", onClick: closeCartOverlay, site: props.site }, "Continue Shopping"),
                    React.createElement(LinkButton, { buttonType: props.site === 'mep' ? 'default' : 'secondary', href: props.basketUrl, site: props.site },
                        "Go to ",
                        props.name)))),
        React.createElement(ToastContainer, { autoClose: 5000, position: "bottom-right" })));
    async function closeCartOverlay() {
        dispatch(basket.actions.setDrawerStatus('closed'));
    }
};
export default CartOverlay;
